
export interface HeroTestimonial {
  name: string;
  role: string;
  company: string;
  image: string;
  text: string;
  rating: number;
  service?: string;
}

export const HERO_TESTIMONIALS: Record<string, HeroTestimonial[]> = {
  'hero-1-original': [
    {
      name: 'Carlos Eduardo Mendes',
      role: 'CEO',
      company: 'Mendes Transportes Ltda',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20executive%20man%20confident%20smile%20modern%20office%20deep%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h1-001&orientation=squarish',
      text: 'A IBX Brasil reduziu nossos custos com seguros em 42% e ainda melhorou nossas coberturas. A análise técnica deles identificou riscos que nem sabíamos que existiam.',
      rating: 5,
      service: 'Assessoria Técnica'
    },
    {
      name: 'Mariana Silva Costa',
      role: 'Diretora Financeira',
      company: 'Costa Indústria e Comércio',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20executive%20confident%20modern%20office%20deep%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h1-002&orientation=squarish',
      text: 'Profissionalismo excepcional. A gestão de contratos da IBX nos poupa tempo e dinheiro. Não precisamos mais nos preocupar com renovações e sinistros.',
      rating: 5,
      service: 'Assessoria Técnica'
    },
    {
      name: 'Roberto Almeida',
      role: 'Empresário',
      company: 'Almeida Construções',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20mature%20confident%20smile%20modern%20office%20deep%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h1-003&orientation=squarish',
      text: 'Depois de um sinistro mal resolvido, contratei a IBX. Eles recuperaram valores que eu achava perdidos e reestruturaram toda nossa estratégia de seguros.',
      rating: 5,
      service: 'Assessoria Técnica'
    }
  ],

  'hero-2-assessoria': [
    {
      name: 'Fernanda Rocha',
      role: 'Sócia-Diretora',
      company: 'Rocha & Associados',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20director%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h2-001&orientation=squarish',
      text: 'Na renovação do nosso seguro empresarial, a IBX identificou que estávamos pagando por coberturas duplicadas. Economizamos R$ 28 mil só na primeira renovação.',
      rating: 5,
      service: 'Assessoria em Renovação'
    },
    {
      name: 'Marcelo Tavares',
      role: 'Gerente Administrativo',
      company: 'Tavares Distribuidora',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20manager%20confident%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h2-002&orientation=squarish',
      text: 'Antes da IBX, renovávamos seguros sem questionar nada. Hoje temos uma assessoria que analisa cada cláusula e negocia com as seguradoras por nós. Diferença enorme.',
      rating: 5,
      service: 'Assessoria em Renovação'
    },
    {
      name: 'Patrícia Lemos',
      role: 'CFO',
      company: 'Lemos Agronegócios',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20CFO%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h2-003&orientation=squarish',
      text: 'A assessoria da IBX na renovação dos nossos seguros rurais foi fundamental. Eles conhecem o mercado profundamente e conseguiram condições que nunca teríamos sozinhos.',
      rating: 5,
      service: 'Assessoria em Renovação'
    }
  ],

  'hero-3-metodo': [
    {
      name: 'André Figueiredo',
      role: 'Diretor Executivo',
      company: 'Figueiredo Logística',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20executive%20director%20confident%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h3-001&orientation=squarish',
      text: 'O Método de Contratação Ativa da IBX mudou completamente nossa visão sobre seguros. Passamos a contratar com estratégia, não mais por impulso ou pressão do corretor.',
      rating: 5,
      service: 'Método de Contratação'
    },
    {
      name: 'Juliana Pires',
      role: 'Gestora de Riscos',
      company: 'Pires Incorporadora',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20risk%20manager%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h3-002&orientation=squarish',
      text: 'Aplicamos o método da IBX em todas as nossas contratações. O resultado foi uma redução de 38% nos custos e coberturas muito mais adequadas ao nosso perfil de risco.',
      rating: 5,
      service: 'Método de Contratação'
    },
    {
      name: 'Sérgio Monteiro',
      role: 'Proprietário',
      company: 'Monteiro Supermercados',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20owner%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h3-003&orientation=squarish',
      text: 'Nunca imaginei que contratar seguro pudesse ser tão estratégico. O método da IBX me ensinou a fazer as perguntas certas e a negociar de igual para igual com as seguradoras.',
      rating: 5,
      service: 'Método de Contratação'
    }
  ],

  'hero-4-profissionalizacao': [
    {
      name: 'Gustavo Henrique Barros',
      role: 'Presidente',
      company: 'Barros Engenharia',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20president%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h4-001&orientation=squarish',
      text: 'Descobrimos que estávamos pagando 48% a mais do que deveríamos. A IBX profissionalizou todo o processo e hoje temos contratos muito mais eficientes e econômicos.',
      rating: 5,
      service: 'Profissionalização'
    },
    {
      name: 'Camila Duarte',
      role: 'Diretora de Operações',
      company: 'Duarte Saúde e Bem-Estar',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20operations%20director%20confident%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h4-002&orientation=squarish',
      text: 'Antes negociávamos seguros diretamente com o corretor sem nenhum suporte técnico. Com a IBX, temos um processo profissional que nos protege de verdade.',
      rating: 5,
      service: 'Profissionalização'
    },
    {
      name: 'Leandro Carvalho',
      role: 'Sócio-Fundador',
      company: 'Carvalho Tech Solutions',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20founder%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h4-003&orientation=squarish',
      text: 'A IBX identificou falhas contratuais graves nos nossos seguros. Se tivéssemos um sinistro antes, teríamos ficado desprotegidos. Hoje dormimos tranquilos.',
      rating: 5,
      service: 'Profissionalização'
    }
  ],

  'hero-5-sinistros': [
    {
      name: 'Ricardo Nunes',
      role: 'Diretor Geral',
      company: 'Nunes Frigorífico',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20general%20director%20confident%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h5-001&orientation=squarish',
      text: 'Tivemos um incêndio e a seguradora queria pagar apenas 40% do valor real do sinistro. A IBX contestou tecnicamente e recuperamos 100% do que tínhamos direito.',
      rating: 5,
      service: 'Recuperação de Sinistros'
    },
    {
      name: 'Elaine Ferreira',
      role: 'Gerente Financeira',
      company: 'Ferreira Atacado',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20financial%20manager%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h5-002&orientation=squarish',
      text: 'Nosso sinistro estava parado há 8 meses sem resolução. A IBX entrou no processo e em 30 dias recebemos a indenização completa. Serviço impecável.',
      rating: 5,
      service: 'Recuperação de Sinistros'
    },
    {
      name: 'Paulo Sérgio Lima',
      role: 'Empresário',
      company: 'Lima Materiais de Construção',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20entrepreneur%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h5-003&orientation=squarish',
      text: 'Achei que meu sinistro estava perdido. A IBX revisou toda a documentação, identificou erros da seguradora e recuperou R$ 340 mil que eu já tinha dado como perdidos.',
      rating: 5,
      service: 'Recuperação de Sinistros'
    }
  ],

  'hero-6-empresarial': [
    {
      name: 'Henrique Souza',
      role: 'CEO',
      company: 'Souza Indústria Têxtil',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20CEO%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h6-001&orientation=squarish',
      text: 'A IBX estruturou um seguro empresarial completo para nossa fábrica. Coberturas que nunca tínhamos considerado e um custo 31% menor que a proposta anterior.',
      rating: 5,
      service: 'Seguro Empresarial'
    },
    {
      name: 'Daniela Matos',
      role: 'Sócia-Proprietária',
      company: 'Matos Clínicas',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20owner%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h6-002&orientation=squarish',
      text: 'Nossas clínicas precisavam de coberturas específicas para responsabilidade civil médica. A IBX encontrou a solução ideal e ainda negociou condições especiais com a seguradora.',
      rating: 5,
      service: 'Seguro Empresarial'
    },
    {
      name: 'Fábio Rezende',
      role: 'Diretor Comercial',
      company: 'Rezende Comércio e Serviços',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20commercial%20director%20confident%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h6-003&orientation=squarish',
      text: 'Tínhamos seguros espalhados em várias seguradoras sem nenhuma estratégia. A IBX consolidou tudo, melhorou as coberturas e reduziu o custo total em 29%.',
      rating: 5,
      service: 'Seguro Empresarial'
    }
  ],

  'hero-7-economia': [
    {
      name: 'Thiago Brandão',
      role: 'CFO',
      company: 'Brandão Holding',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20CFO%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h7-001&orientation=squarish',
      text: 'Economizamos R$ 180 mil por ano nos seguros do grupo sem abrir mão de nenhuma cobertura essencial. A IBX encontrou ineficiências que nosso time interno nunca teria identificado.',
      rating: 5,
      service: 'Redução de Custos'
    },
    {
      name: 'Renata Oliveira',
      role: 'Gestora Administrativa',
      company: 'Oliveira Redes de Franquias',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20administrative%20manager%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h7-002&orientation=squarish',
      text: 'Com 12 unidades franqueadas, nossos custos com seguros eram altíssimos. A IBX negociou um contrato coletivo e reduzimos 37% no total. Resultado extraordinário.',
      rating: 5,
      service: 'Redução de Custos'
    },
    {
      name: 'Marcos Vinícius Teles',
      role: 'Diretor Financeiro',
      company: 'Teles Agropecuária',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20financial%20director%20confident%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h7-003&orientation=squarish',
      text: 'Achávamos que já tínhamos boas condições de seguro. A IBX provou o contrário e nos economizou R$ 95 mil na primeira renovação. Agora são parceiros permanentes.',
      rating: 5,
      service: 'Redução de Custos'
    }
  ],

  'hero-8-gestao': [
    {
      name: 'Adriana Campos',
      role: 'Diretora Jurídica',
      company: 'Campos & Neto Advogados',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20legal%20director%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h8-001&orientation=squarish',
      text: 'Tínhamos 23 contratos de seguro diferentes e perdíamos prazos constantemente. A IBX centralizou tudo e hoje temos visibilidade total. Zero renovações perdidas.',
      rating: 5,
      service: 'Gestão de Contratos'
    },
    {
      name: 'Eduardo Pinheiro',
      role: 'Gerente de Patrimônio',
      company: 'Pinheiro Imóveis',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20property%20manager%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h8-002&orientation=squarish',
      text: 'Gerenciar seguros de 47 imóveis era um caos. Com a IBX, temos um painel completo, alertas de vencimento e renovações estratégicas. Economizamos tempo e dinheiro.',
      rating: 5,
      service: 'Gestão de Contratos'
    },
    {
      name: 'Viviane Corrêa',
      role: 'Superintendente',
      company: 'Corrêa Saúde Hospitalar',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20superintendent%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h8-003&orientation=squarish',
      text: 'A gestão de contratos da IBX nos deu controle total sobre nosso portfólio de seguros. Identificamos duplicidades e economizamos R$ 62 mil só na primeira revisão.',
      rating: 5,
      service: 'Gestão de Contratos'
    }
  ],

  'hero-9-vida': [
    {
      name: 'Rodrigo Santana',
      role: 'Diretor de RH',
      company: 'Santana Tecnologia',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20HR%20director%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h9-001&orientation=squarish',
      text: 'O seguro de vida estruturado pela IBX se tornou um dos benefícios mais valorizados pelos nossos colaboradores. Retenção de talentos melhorou significativamente.',
      rating: 5,
      service: 'Seguro de Vida Empresarial'
    },
    {
      name: 'Cristiane Borges',
      role: 'CEO',
      company: 'Borges Consultoria',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20CEO%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h9-002&orientation=squarish',
      text: 'A IBX estruturou um plano de vida empresarial que protege nossa equipe e garante a continuidade do negócio em caso de imprevistos. Investimento que vale cada centavo.',
      rating: 5,
      service: 'Seguro de Vida Empresarial'
    },
    {
      name: 'Alexandre Moura',
      role: 'Sócio-Gerente',
      company: 'Moura & Filhos Comércio',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20partner%20manager%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h9-003&orientation=squarish',
      text: 'Perdemos um sócio inesperadamente e o seguro de vida empresarial da IBX garantiu a continuidade da empresa. Sem ele, teríamos enfrentado uma crise financeira grave.',
      rating: 5,
      service: 'Seguro de Vida Empresarial'
    }
  ],

  'hero-10-diagnostico': [
    {
      name: 'Beatriz Cunha',
      role: 'Diretora Executiva',
      company: 'Cunha Farmacêutica',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20executive%20director%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h10-001&orientation=squarish',
      text: 'O diagnóstico gratuito da IBX revelou que tínhamos lacunas críticas em nossas coberturas. Ficamos chocados com o que descobrimos. Corrigimos tudo antes de qualquer sinistro.',
      rating: 5,
      service: 'Diagnóstico de Riscos'
    },
    {
      name: 'Nelson Freitas',
      role: 'Proprietário',
      company: 'Freitas Supermercados',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20owner%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h10-002&orientation=squarish',
      text: 'Fiz o diagnóstico achando que estava bem protegido. A IBX identificou 7 pontos críticos de vulnerabilidade. Hoje tenho certeza de que meu negócio está realmente seguro.',
      rating: 5,
      service: 'Diagnóstico de Riscos'
    },
    {
      name: 'Tatiana Vasconcelos',
      role: 'Gestora de Riscos',
      company: 'Vasconcelos Energia',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20risk%20manager%20confident%20smile%20modern%20office%20teal%20background%20corporate%20portrait%20high%20quality%20realistic&width=400&height=400&seq=t-h10-003&orientation=squarish',
      text: 'O diagnóstico da IBX foi o ponto de partida para uma reestruturação completa dos nossos seguros. Economizamos 33% e aumentamos a proteção real do nosso patrimônio.',
      rating: 5,
      service: 'Diagnóstico de Riscos'
    }
  ]
};
